import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function productCategorySelectedValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const obj = control.value;
    if (
      typeof obj === 'object' &&
      obj !== null &&
      typeof obj.name === 'string' &&
      obj.name.trim().length > 0 &&
      (typeof obj.productCategoryId === 'string' || typeof obj.productCategoryId === 'number') &&
      String(obj.productCategoryId).trim().length > 0
    ) {
      return null;
    }
    return { productDescriptionNotSelected: true };
  };
}
